
import XHeader from 'vux/src/components/x-header/index.vue'

export default {
name: 'info',
props: [],
components: {
XHeader
},
data () {
return {

}
},
computed: {
title () {
return this.$route.params.title
}
},
created () {
},
mounted () {
},
updated () {},
destroyed () {},
watch: {},
methods: {
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
},
finish () {
setTimeout(() => {
this.$router.push({name: 'home'})
}, 300)
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/default.vue